// extracted by mini-css-extract-plugin
export default {"container":"ActivityFeed-index__container--Cfq4t","buttonsBar":"ActivityFeed-index__buttonsBar--uB6Rq"};